import React from 'react';
import { MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import {
  buildUrlQueryParams,
  getTranslateByKey,
  isShowControlByElementId
} from '@/main/services/utils';
import { RoutesConstants } from '@/main/routes/routesConstants';
import { Controls } from '@/main/services/constants/constantsControl';
import { ProcurementStatusEnum } from '@/main/services/enum/StatusProcurement';
import { useThreeDotsClaimContext } from '../contex';

interface IOptionReassignPartSearchClaimProps {
  guidClaim: string;
  canShow: boolean;
  idStatus: number;
} 
function ThreeDotsClaimReassignPartSearchClaim({
  guidClaim,
  canShow,
  idStatus
}: IOptionReassignPartSearchClaimProps) {
  const { closeThreeDotsClaim, generateIdMenu } = useThreeDotsClaimContext();
  const navigate = useNavigate();

  const showReassignButton =
    isShowControlByElementId(Controls.IdReassignPart) && canShow;

  function handleReassignClaim() {
    const routeReassignOrder = buildUrlQueryParams(
      RoutesConstants.orderReassignOrderBulk,
      {
        guidClaim
      }
    );
    navigate(routeReassignOrder);
    closeThreeDotsClaim();
  }

  if (!showReassignButton) return <></>;
  return (
    <MenuItem id={generateIdMenu('reassign')} onClick={handleReassignClaim}>
      {getTranslateByKey('information.reassignPartToAnotherSupplier')}
    </MenuItem>
  );
}

export default ThreeDotsClaimReassignPartSearchClaim;
